module.exports = __webpack_public_path__ + "img/people.b938865d.svg";